<template>
    <div :class="['layout-mask', { 'is-active': isActive }]" />
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({
            isActive: 'isMask'
        })
    }
}
</script>

<style lang="scss">
@import 'src/assets/scss/_variables/color';

.layout-mask {
    position: fixed;
    top: 0;
    left: 0;
    pointer-events: none;
    visibility: hidden;
    opacity: 0;
    z-index: 100000;
    transition: 0.15s;
    background-color: rgba($colo-shadow, 0.9);
    height: 100%;
    width: 100%;

    &.is-active {
        pointer-events: all;
        visibility: visible;
        opacity: 1;
    }
}

</style>
